import { create } from "zustand";
import { createAppStore } from "./app";
import { createProfileStore } from "./profile";
import type { State } from "./types";

// https://stackoverflow.com/a/76822802 (For persist with TS)
export const useStore = create<State>((...args) => ({
  ...createProfileStore(...args),
  ...createAppStore(...args),
}));
